import * as actionTypes from 'store/action-types';
import { Action, CreatorDetailsState } from 'shared/interface';

const initialState: CreatorDetailsState = {
	updateObsList: false
};

const reducer = (state: CreatorDetailsState = initialState, action: Action): CreatorDetailsState => {
	switch (action.type) {
		case actionTypes.UPDATE_OBS_VOTING_LIST:
			return {
				updateObsList: action.payload
			};
		default:
			return state;
	}
};
export default reducer;
